import { render, staticRenderFns } from "./highlights.vue?vue&type=template&id=afee7e44&scoped=true"
import script from "./highlights.vue?vue&type=script&lang=js"
export * from "./highlights.vue?vue&type=script&lang=js"
import style0 from "./highlights.vue?vue&type=style&index=0&id=afee7e44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afee7e44",
  null
  
)

export default component.exports